function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["res", "jumpUrl"];
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { getImgUrl } from '@jdhfe/seouifuncs/dist/tools/getImgUrl';
import stylesInner from "./index.less";
import cx from 'classnames';
import { urlForMContJd } from '@jdhfe/seouifuncs/dist/indexForSeo';
import React, { useEffect, useMemo, useRef } from 'react';
import { findDOMNode } from 'react-dom';
import { getSplitPrice } from '@jdhfe/seouifuncs/dist/tools/price';
import { JUMP_UNKNOW_URL } from '@jdhfe/seouifuncs/dist/tools/jump';
import { multipleOrder } from '@jdhfe/seouifuncs/dist/tools/multipleOrder';
import { getNethpHref } from '@jdhfe/seouifuncs/dist/tools/getNethpHref';
import { getUrlParam } from '@jdhfe/seouifuncs/dist/tools/getUrlParam';
import { Dialog, Toast } from "../Popup";
import onlineIcon from "./img/onlineIcon.gif";
import arrow from "./img/arrow2.png";
import { NewTagList } from "./TagList";
import { Ellipsis } from 'antd-mobile';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var toFixed = function toFixed(num, digit) {
  try {
    if (digit === undefined) {
      return num;
    }
    if (typeof num === 'number' || typeof num === 'string') {} else {
      return num;
    }
    if (typeof num === 'number') {} else {
      num = parseFloat(num);
    }
    var hasDot = false;
    if ("".concat(num).includes('.')) {
      hasDot = true;
    }
    if (!hasDot) {
      return num;
    }
    return num.toFixed(digit);
  } catch (e) {
    return num;
  }
};
// 义诊
export function VolunteerLabel(props) {
  var num = props.num,
    volunteerImgUrl = props.volunteerImgUrl,
    _props$styles = props.styles,
    styles = _props$styles === void 0 ? stylesInner : _props$styles;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.volunteer,
    children: [/*#__PURE__*/_jsx("img", {
      className: styles.volunteerTitle,
      src: volunteerImgUrl
    }), /*#__PURE__*/_jsx("div", {
      className: styles.volunteerValue,
      children: /*#__PURE__*/_jsxs("span", {
        className: styles.volunteerValueText,
        children: ["\u5269\u4F59", num, "\u4E2A\u540D\u989D"]
      })
    })]
  });
}
export function RenderFooter(props) {
  var doctor = props.doctor,
    click_Ask = props.click_Ask,
    index = props.index,
    isClicked = props.isClicked,
    _props$styles2 = props.styles,
    styles = _props$styles2 === void 0 ? stylesInner : _props$styles2,
    _props$buttonText = props.buttonText,
    buttonText = _props$buttonText === void 0 ? '问医生' : _props$buttonText;
  var priceDiscountsVolunteerDiag = doctor === null || doctor === void 0 ? void 0 : doctor.priceDiscountsVolunteerDiag;
  var doctorServiceInfo = doctor === null || doctor === void 0 ? void 0 : doctor.doctorServiceInfo;
  var serviceList = (doctorServiceInfo === null || doctorServiceInfo === void 0 ? void 0 : doctorServiceInfo.doctorServiceInfoList) || [];
  var existOtherService = (doctorServiceInfo === null || doctorServiceInfo === void 0 ? void 0 : doctorServiceInfo.existOtherService) || 0;
  if (serviceList.length === 0) {
    return null;
  }
  var showDiscounts = priceDiscountsVolunteerDiag === null || priceDiscountsVolunteerDiag === void 0 ? void 0 : priceDiscountsVolunteerDiag.discounts;
  var price = (priceDiscountsVolunteerDiag === null || priceDiscountsVolunteerDiag === void 0 ? void 0 : priceDiscountsVolunteerDiag.serviceMinPrice) || '';
  var showVolunteer = priceDiscountsVolunteerDiag === null || priceDiscountsVolunteerDiag === void 0 ? void 0 : priceDiscountsVolunteerDiag.volunteerDiag;
  var cardPrice = getSplitPrice(price);
  var isShow = showDiscounts || showVolunteer;
  var discountsImgUrl = 'https://img10.360buyimg.com/imagetools/jfs/t1/66568/19/23960/651/63c60fd6Fa29c7aa6/78d8289447296a16.png';
  var volunteerImgUrl = 'https://img10.360buyimg.com/imagetools/jfs/t1/149846/25/32544/667/63c6104dFcddb8c2a/758e61cd90f16e99.png';
  return /*#__PURE__*/_jsxs("div", {
    className: styles.footer,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.footerLeft,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.footerPrice,
        children: [price !== undefined && /*#__PURE__*/_jsxs("div", {
          className: styles.priceContainer,
          children: [/*#__PURE__*/_jsx("span", {
            className: styles.price,
            children: cardPrice === null || cardPrice === void 0 ? void 0 : cardPrice.currency
          }), /*#__PURE__*/_jsx("span", {
            className: styles.largePrice,
            children: cardPrice === null || cardPrice === void 0 ? void 0 : cardPrice.priceIntNumber
          }), /*#__PURE__*/_jsx("span", {
            className: styles.smallPrice,
            children: cardPrice === null || cardPrice === void 0 ? void 0 : cardPrice.priceFloatNumber
          }), /*#__PURE__*/_jsx("span", {
            className: styles.priceText,
            children: cardPrice === null || cardPrice === void 0 ? void 0 : cardPrice.unit
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: cx([styles.service, isClicked ? styles.opacity : undefined]),
          children: serviceList.map(function (item, index) {
            return /*#__PURE__*/_jsxs(React.Fragment, {
              children: [/*#__PURE__*/_jsxs("div", {
                className: cx(styles.serviceLabel, styles.serviceLabelText),
                children: [item, existOtherService === 1 && index === serviceList.length - 1 ? '等' : null]
              }), index !== serviceList.length - 1 ? /*#__PURE__*/_jsx("div", {
                className: styles.serviceLine
              }) : null]
            }, index);
          })
        })]
      }), isShow && /*#__PURE__*/_jsxs("div", {
        className: styles.footerCoupon,
        children: [showVolunteer && /*#__PURE__*/_jsx(VolunteerLabel, {
          num: priceDiscountsVolunteerDiag === null || priceDiscountsVolunteerDiag === void 0 ? void 0 : priceDiscountsVolunteerDiag.activityRemainingNum,
          volunteerImgUrl: volunteerImgUrl,
          styles: styles
        }), showDiscounts && /*#__PURE__*/_jsx("img", {
          className: styles.coupon,
          src: discountsImgUrl
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: cx([isShow ? styles.footRight : undefined]),
      children: /*#__PURE__*/_jsx("div", {
        className: styles.blueBtn,
        onClick: function onClick(e) {
          click_Ask === null || click_Ask === void 0 || click_Ask(e, index, doctor);
        },
        children: buttonText
      })
    })]
  });
}
export function RenderFooterNew(props) {
  var _extendInfo$showServi, _extendInfo$showServi2, _showServiceInfoReal$;
  var doctor = props.doctor,
    click_Service = props.click_Service,
    api = props.api,
    index = props.index,
    isClicked = props.isClicked,
    isShowDisCount = props.isShowDisCount,
    click_Service_more = props.click_Service_more,
    _props$styles3 = props.styles,
    styles = _props$styles3 === void 0 ? stylesInner : _props$styles3,
    service_more_btn_text = props.service_more_btn_text,
    multipleCustomJumpFun = props.multipleCustomJumpFun,
    click_Service_custom = props.click_Service_custom,
    CustomServiceBtn = props.CustomServiceBtn,
    CustomServiceMoreBtn = props.CustomServiceMoreBtn;
  var priceDiscountsVolunteerDiag = doctor.priceDiscountsVolunteerDiag,
    doctorServiceInfo = doctor.doctorServiceInfo,
    extendInfo = doctor.extendInfo;
  var showDiscounts = priceDiscountsVolunteerDiag === null || priceDiscountsVolunteerDiag === void 0 ? void 0 : priceDiscountsVolunteerDiag.discounts;
  var showVolunteer = priceDiscountsVolunteerDiag === null || priceDiscountsVolunteerDiag === void 0 ? void 0 : priceDiscountsVolunteerDiag.volunteerDiag;
  var isShow = showDiscounts || showVolunteer || isShowDisCount && extendInfo.discountLabelDesc;
  var discountsImgUrl = 'https://img12.360buyimg.com/imagetools/jfs/t1/4523/2/21016/5389/668bb6eaF8e7661a6/2b9c8e810887f60a.png';
  var volunteerImgUrl = 'https://img10.360buyimg.com/imagetools/jfs/t1/149846/25/32544/667/63c6104dFcddb8c2a/758e61cd90f16e99.png';
  var hasFastService = !!(extendInfo !== null && extendInfo !== void 0 && (_extendInfo$showServi = extendInfo.showServiceInfo) !== null && _extendInfo$showServi !== void 0 && _extendInfo$showServi.length);

  // 义诊
  var VolunteerLabel = function VolunteerLabel(props) {
    var num = props.num,
      volunteerImgUrl = props.volunteerImgUrl;
    return /*#__PURE__*/_jsxs("div", {
      className: styles.volunteer,
      children: [/*#__PURE__*/_jsx("img", {
        className: styles.volunteerTitle,
        src: volunteerImgUrl
      }), /*#__PURE__*/_jsx("div", {
        className: styles.volunteerValue,
        children: /*#__PURE__*/_jsxs("span", {
          className: styles.volunteerValueText,
          children: ["\u5269\u4F59", num, "\u4E2A\u540D\u989D"]
        })
      })]
    });
  };
  var footerCouponComp = isShow ?
  /*#__PURE__*/
  // 优惠券、义诊等
  _jsxs("div", {
    className: "".concat(styles.footerCouponNew, " ").concat(hasFastService ? styles.footerFastCoupon : ''),
    children: [extendInfo.discountLabelDesc && isShowDisCount && /*#__PURE__*/_jsxs("div", {
      className: styles.discountLabel,
      children: [/*#__PURE__*/_jsx("span", {
        className: styles.title,
        children: "\u56FE\u6587"
      }), /*#__PURE__*/_jsx("div", {
        className: styles.value,
        children: /*#__PURE__*/_jsx("span", {
          className: styles.volunteerValueText,
          children: extendInfo.discountLabelDesc
        })
      })]
    }), showVolunteer && /*#__PURE__*/_jsx(VolunteerLabel, {
      num: priceDiscountsVolunteerDiag === null || priceDiscountsVolunteerDiag === void 0 ? void 0 : priceDiscountsVolunteerDiag.activityRemainingNum,
      volunteerImgUrl: volunteerImgUrl
    }), showDiscounts && /*#__PURE__*/_jsx("img", {
      className: styles.coupon,
      src: discountsImgUrl
    })]
  }) : null;
  var renderFastServiceLen = 2;
  var showServiceInfoReal =
  // @ts-ignore
  (extendInfo === null || extendInfo === void 0 || (_extendInfo$showServi2 = extendInfo.showServiceInfo) === null || _extendInfo$showServi2 === void 0 ? void 0 : _extendInfo$showServi2.slice(0, renderFastServiceLen)) || (doctor === null || doctor === void 0 ? void 0 : doctor.serviceList); // serviceList 是预问诊的推荐列表的数据  extendInfo?.showServiceInfo这个是医生列表的数据
  var picstr = showServiceInfoReal === null || showServiceInfoReal === void 0 || (_showServiceInfoReal$ = showServiceInfoReal.map(function (_item) {
    return "\xA5".concat(_item.currentPrice !== undefined ? toFixed(_item.currentPrice, 2) : _item.jdPrice);
  })) === null || _showServiceInfoReal$ === void 0 || (_showServiceInfoReal$ = _showServiceInfoReal$.join('')) === null || _showServiceInfoReal$ === void 0 ? void 0 : _showServiceInfoReal$.length;
  if (!footerCouponComp && !(showServiceInfoReal !== null && showServiceInfoReal !== void 0 && showServiceInfoReal.length)) {
    return null;
  }
  var moreBtn = /*#__PURE__*/_jsxs("div", {
    className: styles.fastServiceMore,
    onClick: function onClick(e) {
      click_Service_more === null || click_Service_more === void 0 || click_Service_more(e, index, doctor, undefined);
    },
    children: [/*#__PURE__*/_jsx("span", {
      className: styles.fastServiceMoreText,
      children: service_more_btn_text || '更多服务'
    }), /*#__PURE__*/_jsx("img", {
      className: styles.fastServiceMoreIco,
      src: 'https://img11.360buyimg.com/imagetools/jfs/t1/217626/9/28711/355/6464412eFd0d5a6c7/128a9aa330cc0c43.png'
    })]
  });
  return /*#__PURE__*/_jsxs("div", {
    className: styles.footerFast,
    children: [footerCouponComp && /*#__PURE__*/_jsx("div", {
      className: styles.fastCoupon,
      children: footerCouponComp
    }), (showServiceInfoReal === null || showServiceInfoReal === void 0 ? void 0 : showServiceInfoReal.length) > 0 && /*#__PURE__*/_jsxs("div", {
      className: styles.fastService,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.fastServiceList,
        children: showServiceInfoReal === null || showServiceInfoReal === void 0 ? void 0 : showServiceInfoReal.map(function (serviceItem, serviceIndex) {
          var _serviceItem$serviceT, _prcieDesc;
          var prcieDesc = '';
          var prcieUnit = '';
          var jdPriceDesc = serviceItem.jdPriceDesc;
          if (jdPriceDesc) {
            if (jdPriceDesc.includes('/')) {
              var aa = jdPriceDesc === null || jdPriceDesc === void 0 ? void 0 : jdPriceDesc.split('/');
              prcieDesc = aa[0] || '';
              prcieUnit = "/".concat(aa[1]);
            } else if (jdPriceDesc.includes('起')) {
              var _aa = jdPriceDesc === null || jdPriceDesc === void 0 ? void 0 : jdPriceDesc.split('起');
              prcieDesc = _aa[0] || '';
              prcieUnit = "\u8D77";
            }
          }
          var serviceTypeNameReal = (_serviceItem$serviceT = serviceItem.serviceTypeName) === null || _serviceItem$serviceT === void 0 ? void 0 : _serviceItem$serviceT.replace('问诊', '');
          if (!serviceTypeNameReal) {
            return /*#__PURE__*/_jsx(React.Fragment, {}, serviceItem === null || serviceItem === void 0 ? void 0 : serviceItem.skuId);
          }
          var btn = /*#__PURE__*/_jsxs("div", {
            className: "".concat(styles.fastServiceItem, " ").concat(picstr >= 10 ? styles.smFastServiceItem : ''),
            onClick: function onClick(e) {
              var jumpUrl = serviceItem.jumpUrl;
              var searchValue = props.searchValue,
                index = props.index;
              if (click_Service_custom) {
                click_Service_custom === null || click_Service_custom === void 0 || click_Service_custom(e, index, doctor, serviceItem, undefined, serviceIndex, {
                  jumpUrl: jumpUrl,
                  res: undefined
                });
                return;
              }
              if (!jumpUrl) {
                click_Service === null || click_Service === void 0 || click_Service(e, index, doctor, serviceItem, undefined, serviceIndex, {
                  jumpUrl: jumpUrl,
                  res: undefined
                });
                return;
              }
              e.stopPropagation();
              index += 1;
              if (searchValue === '') {
                searchValue = '-100';
              }
              var urlParam = getUrlParam();
              var isAllFinishParams = {
                timestamp: new Date().getTime(),
                doctorId: doctor === null || doctor === void 0 ? void 0 : doctor.doctorId,
                source: (urlParam === null || urlParam === void 0 ? void 0 : urlParam.source) || 1,
                productId: serviceItem.skuId,
                extendInfo: {
                  jumpFun: function jumpFun(url) {
                    if (multipleCustomJumpFun) {
                      multipleCustomJumpFun(url);
                      return;
                    }
                    if (url) {
                      var _getNethpHref, _getNethpHref$webview;
                      getNethpHref === null || getNethpHref === void 0 || (_getNethpHref = getNethpHref()) === null || _getNethpHref === void 0 || (_getNethpHref$webview = _getNethpHref.webviewRedirect) === null || _getNethpHref$webview === void 0 || _getNethpHref$webview.call(_getNethpHref, url);
                      return;
                    }
                  }
                }
              };
              var confirmFun = function confirmFun() {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                  _ref$title = _ref.title,
                  title = _ref$title === void 0 ? '' : _ref$title,
                  _ref$content = _ref.content,
                  content = _ref$content === void 0 ? '' : _ref$content,
                  _onCancel = _ref.onCancel,
                  onOk = _ref.onOk,
                  res = _ref.res,
                  jumpUrl = _ref.jumpUrl;
                if (!title && !content) {
                  return;
                }
                return Dialog.show({
                  content: content,
                  confirmText: '立即处理',
                  cancelText: '我知道了',
                  onConfirm: function onConfirm() {
                    if (!click_Service) {
                      onOk();
                    } else {
                      click_Service === null || click_Service === void 0 || click_Service(e, index, doctor, serviceItem, undefined, serviceIndex, {
                        jumpUrl: jumpUrl,
                        res: res
                      });
                    }
                  },
                  onCancel: function onCancel() {
                    _onCancel();
                  }
                });
              };
              multipleOrder({
                queryMultipleOrderByPatientAndDoctor: api.BNHFQueryMultipleOrderByPatientAndDoctor
              }, isAllFinishParams, function (reData, isWarn) {
                if (!click_Service) {
                  if (jumpUrl) {
                    var _getNethpHref2, _getNethpHref2$webvie;
                    getNethpHref === null || getNethpHref === void 0 || (_getNethpHref2 = getNethpHref()) === null || _getNethpHref2 === void 0 || (_getNethpHref2$webvie = _getNethpHref2.webviewRedirect) === null || _getNethpHref2$webvie === void 0 || _getNethpHref2$webvie.call(_getNethpHref2, jumpUrl);
                    return;
                  }
                } else {
                  click_Service === null || click_Service === void 0 || click_Service(e, index, doctor, serviceItem, undefined, serviceIndex, {
                    jumpUrl: jumpUrl,
                    res: reData
                  });
                }
              }, undefined, undefined,
              // async (p, resData) => {},
              true, function () {
                var info = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                // const { duration = 2000, content = '', afterClose } = info;
                var res = info.res,
                  jumpUrl = info.jumpUrl,
                  toastOtherInfo = _objectWithoutProperties(info, _excluded);
                return Toast.show(_objectSpread({
                  maskStyle: {
                    zIndex: 1001
                  },
                  maskClickable: false
                }, toastOtherInfo));
              }, confirmFun);
            },
            children: [/*#__PURE__*/_jsx("span", {
              className: styles.serviceTypeName,
              children: serviceTypeNameReal
            }), /*#__PURE__*/_jsx("span", {
              className: "".concat(styles.jdPrice, " ").concat(picstr >= 10 ? styles.smJdPrice : ''),
              children: (_prcieDesc = prcieDesc) === null || _prcieDesc === void 0 ? void 0 : _prcieDesc.replace(/￥/g, '¥')
            }), /*#__PURE__*/_jsx("span", {
              className: styles.jdPriceUnit,
              children: prcieUnit
            })]
          }, serviceItem === null || serviceItem === void 0 ? void 0 : serviceItem.skuId);
          if (CustomServiceBtn) {
            return /*#__PURE__*/_jsx(CustomServiceBtn, {
              data: doctor,
              children: btn
            });
          }
          return btn;
        })
      }), CustomServiceMoreBtn ? /*#__PURE__*/_jsx(CustomServiceMoreBtn, {
        data: doctor,
        children: moreBtn
      }) : moreBtn]
    })]
  });
}
export function RenderService(props) {
  var doctor = props.doctor,
    isClicked = props.isClicked,
    _props$styles4 = props.styles,
    styles = _props$styles4 === void 0 ? stylesInner : _props$styles4;
  var doctorServiceInfo = doctor === null || doctor === void 0 ? void 0 : doctor.doctorServiceInfo;
  var list = (doctorServiceInfo === null || doctorServiceInfo === void 0 ? void 0 : doctorServiceInfo.doctorServiceInfoList) || [];
  return /*#__PURE__*/_jsx("div", {
    className: cx([styles.service, isClicked ? styles.opacity : undefined]),
    children: list.map(function (item, index) {
      return /*#__PURE__*/_jsxs(React.Fragment, {
        children: [/*#__PURE__*/_jsx("span", {
          className: cx(styles.label, styles.serviceLabel, styles.serviceLabelText),
          children: item
        }, index), index !== list.length - 1 ? /*#__PURE__*/_jsx("div", {
          className: styles.serviceLine
        }) : null]
      }, index);
    })
  });
}
export function RenderDisease(props) {
  var doctor = props.doctor,
    isClicked = props.isClicked,
    _props$styles5 = props.styles,
    styles = _props$styles5 === void 0 ? stylesInner : _props$styles5;
  var diseaseLabelInfo = doctor === null || doctor === void 0 ? void 0 : doctor.diseaseLabelInfo;
  var list = (diseaseLabelInfo === null || diseaseLabelInfo === void 0 ? void 0 : diseaseLabelInfo.diseaseLabels) || [];
  if (list.length === 0) return /*#__PURE__*/_jsx(_Fragment, {});
  return /*#__PURE__*/_jsx("div", {
    className: cx([styles.disease, isClicked ? styles.opacity : undefined]),
    children: list.map(function (item) {
      // @ts-ignore
      var isHighlight = item.highlight === 1;
      return /*#__PURE__*/_jsxs("span", {
        className: cx(styles.label, styles.diseaseLabel, styles.diseaseLabelText, isHighlight ? styles.diseaseUnNormalLabel : undefined),
        children: [item.disease, " ", item.count || '']
      }, item.disease);
    })
  });
}

// 文字高亮
export function BrushText(props) {
  var searchValue = props.searchValue,
    str = props.str,
    _props$styles6 = props.styles,
    styles = _props$styles6 === void 0 ? stylesInner : _props$styles6;
  if (!searchValue || searchValue.length === 0 || !str || !searchValue.some(function (item) {
    return str.includes(item);
  })) {
    return /*#__PURE__*/_jsx("span", {
      className: styles.goodAtText,
      children: str
    });
  }
  var newArr = useMemo(function () {
    var tempMark = "______________";
    var v1 = searchValue.reduce(function (v, item, index) {
      var _v;
      if ((_v = v) !== null && _v !== void 0 && _v.replaceAll) {
        var _v2, _v2$replaceAll;
        v = (_v2 = v) === null || _v2 === void 0 || (_v2$replaceAll = _v2.replaceAll) === null || _v2$replaceAll === void 0 ? void 0 : _v2$replaceAll.call(_v2, item, "".concat(tempMark).concat(index).concat(tempMark));
      }
      return v;
    }, str);
    var sStr = v1.split(tempMark);

    // console.log(v1, sStr);

    return sStr.map(function (item, index) {
      var mark = parseInt(item).toString() === item;
      var searchText = mark ? searchValue[parseInt(item)] : '';
      return /*#__PURE__*/_jsx("span", {
        className: cx([styles.goodAtText, mark ? styles.mark : undefined]),
        children: mark ? searchText : item
      }, index);
    });
  }, [searchValue, str]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: newArr
  });
}
export function RenderGoodAt(props) {
  var _doctor$goodAtInfo, _doctor$goodAtInfo2, _doctor$goodAtInfo3, _doctor$goodAtInfo4;
  var doctor = props.doctor,
    index = props.index,
    isClicked = props.isClicked,
    searchValue = props.searchValue,
    _props$config = props.config,
    config = _props$config === void 0 ? {} : _props$config,
    _props$styles7 = props.styles,
    styles = _props$styles7 === void 0 ? stylesInner : _props$styles7,
    click_Adept = props.click_Adept;
  var str = doctor !== null && doctor !== void 0 && (_doctor$goodAtInfo = doctor.goodAtInfo) !== null && _doctor$goodAtInfo !== void 0 && _doctor$goodAtInfo.doctorGoodAtDesc || doctor !== null && doctor !== void 0 && (_doctor$goodAtInfo2 = doctor.goodAtInfo) !== null && _doctor$goodAtInfo2 !== void 0 && _doctor$goodAtInfo2.doctorGoodAt ? "".concat((doctor === null || doctor === void 0 || (_doctor$goodAtInfo3 = doctor.goodAtInfo) === null || _doctor$goodAtInfo3 === void 0 ? void 0 : _doctor$goodAtInfo3.doctorGoodAtDesc) || '', "\uFF1A").concat((doctor === null || doctor === void 0 || (_doctor$goodAtInfo4 = doctor.goodAtInfo) === null || _doctor$goodAtInfo4 === void 0 ? void 0 : _doctor$goodAtInfo4.doctorGoodAt) || '') : '';
  if (!str) {
    return null;
  }
  var _config$goodAt_zheDie = config.goodAt_zheDie,
    goodAt_zheDie = _config$goodAt_zheDie === void 0 ? true : _config$goodAt_zheDie,
    _config$goodAt_zheDie2 = config.goodAt_zheDieIco,
    goodAt_zheDieIco = _config$goodAt_zheDie2 === void 0 ? true : _config$goodAt_zheDie2,
    _config$goodAt_zheDie3 = config.goodAt_zheDieRow,
    goodAt_zheDieRow = _config$goodAt_zheDie3 === void 0 ? 2 : _config$goodAt_zheDie3;
  var brushComp = /*#__PURE__*/_jsx(BrushText, {
    str: str,
    searchValue: searchValue
  });
  var zheDieIco = goodAt_zheDieIco ? /*#__PURE__*/_jsx("img", {
    src: arrow,
    alt: ""
  }) : '';
  var zheDieRow = Number(goodAt_zheDieRow) || 2;
  return /*#__PURE__*/_jsxs("div", {
    className: cx([styles.goodAtWrap, isClicked ? styles.opacity : undefined, !goodAt_zheDie ? styles["numberOfLines".concat(zheDieRow)] : undefined])
    // onClick={(e) => {
    //   // if (goodAt_zheDie) {
    //   //   e.stopPropagation();
    //   // }
    // }}
    ,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.BrushTextBox,
      children: brushComp
    }), goodAt_zheDie ? /*#__PURE__*/_jsx(Ellipsis, {
      className: styles.Ellipsis,
      direction: "end",
      content: str,
      rows: zheDieRow
      // @ts-ignore
      ,
      expandText: /*#__PURE__*/_jsx("div", {
        className: cx(styles.arrowDetail),
        onClick: function onClick(e) {
          // e.stopPropagation();
          click_Adept === null || click_Adept === void 0 || click_Adept(e, index, doctor, undefined, undefined, 'expand');
        },
        children: zheDieIco
      })
      // @ts-ignore
      ,
      collapseText: /*#__PURE__*/_jsx("div", {
        className: cx(styles.arrowDetail, styles.arrowDetailMore),
        onClick: function onClick(e) {
          // e.stopPropagation();
          click_Adept === null || click_Adept === void 0 || click_Adept(e, index, doctor, undefined, undefined, 'collapse');
        },
        children: zheDieIco
      }),
      stopPropagationForActionButtons: ['click']
    }) : brushComp]
  });
}
export function RenderFeedback(props) {
  var _doctor$doctorInfo, _doctor$professionInf;
  var doctor = props.doctor,
    isClicked = props.isClicked,
    _props$styles8 = props.styles,
    styles = _props$styles8 === void 0 ? stylesInner : _props$styles8;
  var settled = !!(doctor !== null && doctor !== void 0 && (_doctor$doctorInfo = doctor.doctorInfo) !== null && _doctor$doctorInfo !== void 0 && _doctor$doctorInfo.settled);
  if (!settled) {
    return null;
  }
  var feedbackInfo = doctor === null || doctor === void 0 ? void 0 : doctor.feedbackInfo;
  // @ts-ignore
  var professionType = doctor === null || doctor === void 0 || (_doctor$professionInf = doctor.professionInfoList) === null || _doctor$professionInf === void 0 || (_doctor$professionInf = _doctor$professionInf[0]) === null || _doctor$professionInf === void 0 ? void 0 : _doctor$professionInf.professionType;
  var _ref2 = feedbackInfo || {},
    averageResponseTimeDTO = _ref2.averageResponseTimeDTO;
  var newWaitFeedbackValue1 = averageResponseTimeDTO ? "".concat(averageResponseTimeDTO.averageResponseTime || '') : '';
  var newWaitFeedbackValue2 = averageResponseTimeDTO ? "".concat(averageResponseTimeDTO.timeUnit || '').concat(averageResponseTimeDTO.suffixText || '') : '';
  var newWaitFeedbackLabel = averageResponseTimeDTO ? averageResponseTimeDTO.prefixText : '';
  return /*#__PURE__*/_jsxs("div", {
    className: cx([styles.feedback, isClicked ? styles.opacity : undefined]),
    children: [/*#__PURE__*/_jsx("span", {
      className: styles.feedbackLabel,
      children: "\u597D\u8BC4"
    }), /*#__PURE__*/_jsx("span", {
      className: styles.feedbackValue,
      children: (feedbackInfo === null || feedbackInfo === void 0 ? void 0 : feedbackInfo.patientEvaluationRate) || '-'
    }), /*#__PURE__*/_jsx("div", {
      className: styles.line
    }), /*#__PURE__*/_jsx("span", {
      className: styles.feedbackLabel,
      children: [6, 17].includes(professionType) ? '咨询量' : '接诊量'
    }), /*#__PURE__*/_jsx("span", {
      className: styles.feedbackValue,
      children: (feedbackInfo === null || feedbackInfo === void 0 ? void 0 : feedbackInfo.receivePatientNum) || '-'
    }), /*#__PURE__*/_jsx("div", {
      className: styles.line
    }), averageResponseTimeDTO ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("span", {
        className: styles.feedbackLabel,
        children: newWaitFeedbackLabel
      }), /*#__PURE__*/_jsx("span", {
        className: styles.feedbackValue,
        children: newWaitFeedbackValue1 || '-'
      }), newWaitFeedbackValue2 ? /*#__PURE__*/_jsx("span", {
        className: styles.feedbackValueTip,
        children: newWaitFeedbackValue2
      }) : null]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("span", {
        className: styles.feedbackLabel,
        children: "\u5E73\u5747\u7B49\u5F85"
      }), /*#__PURE__*/_jsx("span", {
        className: styles.feedbackValue,
        children: (feedbackInfo === null || feedbackInfo === void 0 ? void 0 : feedbackInfo.averageResponseTime) || '-'
      })]
    })]
  });
}
export function RenderDoctorTag(props) {
  var doctor = props.doctor,
    isClicked = props.isClicked,
    _props$styles9 = props.styles,
    styles = _props$styles9 === void 0 ? stylesInner : _props$styles9;
  return /*#__PURE__*/_jsx("div", {
    className: styles.marketingLabelBox,
    children: /*#__PURE__*/_jsx(NewTagList, {
      data: doctor,
      tagSectionType: "marketingLabel",
      cfg: undefined
    })
  });
}
RenderDoctorTag.selfToastId = '';
export function RenderHospital(props) {
  var _doctor$doctorLabel, _doctor$hospitalInfo;
  var doctor = props.doctor,
    isClicked = props.isClicked,
    click_Hos = props.click_Hos,
    index = props.index,
    _props$styles10 = props.styles,
    styles = _props$styles10 === void 0 ? stylesInner : _props$styles10,
    CustomHosBtn = props.CustomHosBtn;
  var hospitalInfo = doctor === null || doctor === void 0 ? void 0 : doctor.hospitalInfo;
  var hos = /*#__PURE__*/_jsxs("div", {
    className: cx([styles.hospital, isClicked ? styles.opacity : undefined]),
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.generalLabelBox,
      children: /*#__PURE__*/_jsx(NewTagList, {
        data: doctor,
        tagSectionType: "generalLabel",
        cfg: undefined
      })
    }), /*#__PURE__*/_jsx("div", {
      className: cx(styles.hospitalNameWrap, _defineProperty({}, styles.hasTag, ((doctor === null || doctor === void 0 || (_doctor$doctorLabel = doctor.doctorLabel) === null || _doctor$doctorLabel === void 0 || (_doctor$doctorLabel = _doctor$doctorLabel.generalLabel) === null || _doctor$doctorLabel === void 0 ? void 0 : _doctor$doctorLabel.length) || 0) > 0)),
      children: /*#__PURE__*/_jsx("span", {
        className: cx(styles.hospitalName, styles.numberOfLines1),
        "data-a-href": urlForMContJd("/hospital/".concat(doctor === null || doctor === void 0 || (_doctor$hospitalInfo = doctor.hospitalInfo) === null || _doctor$hospitalInfo === void 0 ? void 0 : _doctor$hospitalInfo.hospitalId)),
        onClick: function onClick(e) {
          click_Hos === null || click_Hos === void 0 || click_Hos(e, index, doctor);
        },
        children: hospitalInfo === null || hospitalInfo === void 0 ? void 0 : hospitalInfo.hospitalName
      })
    })]
  });
  if (CustomHosBtn) {
    return /*#__PURE__*/_jsx(CustomHosBtn, {
      data: doctor,
      children: hos
    });
  }
  return hos;
}
export function RenderBaseInfo(props) {
  var _doctor$doctorInfo2, _doctor$doctorInfo3, _doctor$hospitalInfo2, _doctor$hospitalInfo3, _doctor$hospitalInfo4, _doctor$hospitalInfo5, _doctor$doctorInfo4;
  var doctor = props.doctor,
    isClicked = props.isClicked,
    _props$styles11 = props.styles,
    styles = _props$styles11 === void 0 ? stylesInner : _props$styles11;
  return /*#__PURE__*/_jsxs("div", {
    className: cx([styles.baseInfo, isClicked ? styles.opacity : undefined]),
    children: [/*#__PURE__*/_jsx("span", {
      className: cx(styles.baseInfoDoctorName, styles.numberOfLines1),
      "data-a-href": urlForMContJd("/doctor/".concat(doctor === null || doctor === void 0 ? void 0 : doctor.doctorId)),
      children: doctor === null || doctor === void 0 || (_doctor$doctorInfo2 = doctor.doctorInfo) === null || _doctor$doctorInfo2 === void 0 ? void 0 : _doctor$doctorInfo2.doctorName
    }), /*#__PURE__*/_jsx("span", {
      className: cx(styles.baseInfoDoctorTitle, styles.numberOfLines1),
      children: doctor === null || doctor === void 0 || (_doctor$doctorInfo3 = doctor.doctorInfo) === null || _doctor$doctorInfo3 === void 0 ? void 0 : _doctor$doctorInfo3.doctorTitleName
    }), doctor !== null && doctor !== void 0 && (_doctor$hospitalInfo2 = doctor.hospitalInfo) !== null && _doctor$hospitalInfo2 !== void 0 && _doctor$hospitalInfo2.secondDepartName || doctor !== null && doctor !== void 0 && (_doctor$hospitalInfo3 = doctor.hospitalInfo) !== null && _doctor$hospitalInfo3 !== void 0 && _doctor$hospitalInfo3.departmentName ? /*#__PURE__*/_jsx("div", {
      className: styles.line
    }) : null, /*#__PURE__*/_jsx("span", {
      className: cx(styles.doctorDepName, styles.numberOfLines1),
      children: (doctor === null || doctor === void 0 || (_doctor$hospitalInfo4 = doctor.hospitalInfo) === null || _doctor$hospitalInfo4 === void 0 ? void 0 : _doctor$hospitalInfo4.secondDepartName) || (doctor === null || doctor === void 0 || (_doctor$hospitalInfo5 = doctor.hospitalInfo) === null || _doctor$hospitalInfo5 === void 0 ? void 0 : _doctor$hospitalInfo5.departmentName)
    }), /*#__PURE__*/_jsx("p", {
      style: {
        display: 'none'
      },
      children: (doctor === null || doctor === void 0 || (_doctor$doctorInfo4 = doctor.doctorInfo) === null || _doctor$doctorInfo4 === void 0 ? void 0 : _doctor$doctorInfo4.personalProfile) || ''
    })]
  });
}
export function RenderCardLeft(props) {
  var _doctor$doctorInfo5, _doctor$doctorInfo6;
  var doctor = props.doctor,
    index = props.index,
    click_HeadImg = props.click_HeadImg,
    _props$styles12 = props.styles,
    styles = _props$styles12 === void 0 ? stylesInner : _props$styles12;
  var onlineTag = doctor === null || doctor === void 0 || (_doctor$doctorInfo5 = doctor.doctorInfo) === null || _doctor$doctorInfo5 === void 0 ? void 0 : _doctor$doctorInfo5.onlineTag;
  var imageUrl = getImgUrl(doctor === null || doctor === void 0 || (_doctor$doctorInfo6 = doctor.doctorInfo) === null || _doctor$doctorInfo6 === void 0 ? void 0 : _doctor$doctorInfo6.doctorHeadPic, 50);
  return /*#__PURE__*/_jsx("div", {
    className: styles.left,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.onlineImgBoxBox,
      children: [/*#__PURE__*/_jsx("div", {
        className: cx([styles.doctorImgBox]),
        onClick: function onClick(e) {
          click_HeadImg === null || click_HeadImg === void 0 || click_HeadImg(e, index, doctor);
        },
        children: /*#__PURE__*/_jsx("img", {
          className: styles.doctorImg,
          src: imageUrl
        })
      }), onlineTag ? /*#__PURE__*/_jsx("img", {
        className: styles.onlineIconActive,
        src: onlineIcon
      }) : null]
    })
  });
}
export function DoctorItemCard(props) {
  var _doctor$doctorInfo7;
  var className = props.className,
    doctor = props.doctor,
    index = props.index,
    isClicked = props.isClicked,
    searchValue = props.searchValue,
    onMount = props.onMount,
    onExposed = props.onExposed,
    click_Card = props.click_Card,
    click_Adept = props.click_Adept,
    click_HeadImg = props.click_HeadImg,
    click_Hos = props.click_Hos,
    click_Ask = props.click_Ask,
    click_Service = props.click_Service,
    click_Service_more = props.click_Service_more,
    multipleCustomJumpFun = props.multipleCustomJumpFun,
    CustomClickCard = props.CustomClickCard,
    CustomHosBtn = props.CustomHosBtn,
    CustomServiceBtn = props.CustomServiceBtn,
    CustomServiceMoreBtn = props.CustomServiceMoreBtn,
    isShowDisCount = props.isShowDisCount,
    config = props.config,
    cfg = props.cfg,
    api = props.api,
    newFeedbackRank = props.newFeedbackRank,
    outStyles = props.styles,
    service_more_btn_text = props.service_more_btn_text;
  var styles = useMemo(function () {
    return _objectSpread(_objectSpread({}, stylesInner), outStyles);
  }, [outStyles]);
  var ioExposed = useRef({
    io: null,
    isExposed: false
  });
  var cardRed = useRef();
  useEffect(function () {
    if (!doctor) {
      return;
    }
    onMount === null || onMount === void 0 || onMount(index, doctor);
    if (!onExposed) {
      return;
    }

    // H5 曝光
    var intersectionObserverCallback = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!ioExposed.current.isExposed && event && event[0] && event[0].isIntersecting) {
                ioExposed.current.isExposed = true;
                onExposed === null || onExposed === void 0 || onExposed(index, doctor);
              }
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function intersectionObserverCallback(_x) {
        return _ref3.apply(this, arguments);
      };
    }();
    if (IntersectionObserver && !ioExposed.current.io && !ioExposed.current.isExposed) {
      ioExposed.current.io = new IntersectionObserver(intersectionObserverCallback, {});
    }
    if (cardRed.current && ioExposed.current.io && ioExposed.current.io.observe) {
      var _ioExposed$current$io, _ioExposed$current$io2;
      var dom = findDOMNode(cardRed.current);
      if (!dom) {
        return;
      }
      // 监听
      (_ioExposed$current$io = (_ioExposed$current$io2 = ioExposed.current.io).observe) === null || _ioExposed$current$io === void 0 || _ioExposed$current$io.call(_ioExposed$current$io2, dom);
    }
    return function () {
      if (ioExposed.current.io) {
        var _ioExposed$current$io3, _ioExposed$current$io4;
        // 关闭观察器
        (_ioExposed$current$io3 = (_ioExposed$current$io4 = ioExposed.current.io).disconnect) === null || _ioExposed$current$io3 === void 0 || _ioExposed$current$io3.call(_ioExposed$current$io4);
      }
    };
  }, []);
  if (!doctor) {
    return null;
  }
  var settled = !!((_doctor$doctorInfo7 = doctor.doctorInfo) !== null && _doctor$doctorInfo7 !== void 0 && _doctor$doctorInfo7.settled);

  // @ts-ignore
  var bgImg = doctor.backgroundImg;
  // const bgImg = 'https://img11.360buyimg.com/imagetools/jfs/t1/160410/14/40108/5772/64dc8064Fcc1abf2e/0d1dc1d789648e01.png';

  var renderFeedbackDom = settled && /*#__PURE__*/_jsx(RenderFeedback, {
    doctor: doctor,
    index: index,
    isClicked: isClicked,
    styles: styles
  });
  var Card = /*#__PURE__*/_jsxs("div", {
    ref: cardRed,
    className: cx([styles.root, className]),
    onClick: function onClick(e) {
      var jumpFunc = function jumpFunc() {
        var _doctor$doctorInfo8, _getNethpHref3, _getNethpHref3$webvie;
        var jurl = "https://laputa.healthjd.com/doctor_home/doctorHome/home?doctorId=".concat(doctor.doctorId);
        // 表示是黄页医生
        if (!(doctor !== null && doctor !== void 0 && (_doctor$doctorInfo8 = doctor.doctorInfo) !== null && _doctor$doctorInfo8 !== void 0 && _doctor$doctorInfo8.settled)) {
          jurl = "https://laputa.healthjd.com/doctor_yellow/doctorHome/home?yellowDoctorId=".concat(doctor.doctorId);
        }
        jurl = JUMP_UNKNOW_URL(jurl); // 小程序下跳转要加工参数
        getNethpHref === null || getNethpHref === void 0 || (_getNethpHref3 = getNethpHref()) === null || _getNethpHref3 === void 0 || (_getNethpHref3$webvie = _getNethpHref3.webviewRedirect) === null || _getNethpHref3$webvie === void 0 || _getNethpHref3$webvie.call(_getNethpHref3, jurl);
      };
      if (!click_Card) {
        jumpFunc();
      } else {
        click_Card === null || click_Card === void 0 || click_Card(e, index, doctor, undefined, jumpFunc);
      }
    },
    children: [bgImg ? /*#__PURE__*/_jsx("div", {
      className: styles.CardBgImg,
      children: /*#__PURE__*/_jsx("img", {
        className: styles.doctorBgImg,
        src: bgImg,
        alt: ""
      })
    }) : null, /*#__PURE__*/_jsxs("div", {
      className: styles.cardContent,
      children: [/*#__PURE__*/_jsx(RenderCardLeft, {
        doctor: doctor,
        index: index,
        click_HeadImg: click_HeadImg,
        styles: styles
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.right,
        children: [/*#__PURE__*/_jsx(RenderBaseInfo, {
          doctor: doctor,
          index: index,
          isClicked: isClicked,
          styles: styles
        }), /*#__PURE__*/_jsx(RenderHospital, {
          doctor: doctor,
          index: index,
          isClicked: isClicked,
          click_Hos: click_Hos,
          CustomHosBtn: CustomHosBtn,
          styles: styles
        }), /*#__PURE__*/_jsx(RenderDoctorTag, {
          doctor: doctor,
          index: index,
          isClicked: isClicked,
          styles: styles
        }), newFeedbackRank ? null : renderFeedbackDom, /*#__PURE__*/_jsx(RenderGoodAt, {
          doctor: doctor,
          index: index,
          click_Adept: click_Adept,
          isClicked: isClicked,
          config: config,
          searchValue: searchValue,
          styles: styles
        }), /*#__PURE__*/_jsx(RenderDisease, {
          doctor: doctor,
          index: index,
          isClicked: isClicked,
          styles: styles
        }), newFeedbackRank ? renderFeedbackDom : null, (cfg === null || cfg === void 0 ? void 0 : cfg.serviceStyle) != 1 ? /*#__PURE__*/_jsx(RenderFooter, {
          doctor: doctor,
          index: index,
          click_Ask: click_Ask,
          isClicked: isClicked,
          styles: styles,
          buttonText: props === null || props === void 0 ? void 0 : props.buttonText
        }) : /*#__PURE__*/_jsx(RenderFooterNew, {
          doctor: doctor,
          index: index,
          api: api,
          multipleCustomJumpFun: multipleCustomJumpFun,
          click_Service: click_Service,
          click_Service_more: click_Service_more,
          isClicked: isClicked,
          styles: styles,
          isShowDisCount: isShowDisCount,
          service_more_btn_text: service_more_btn_text,
          CustomServiceBtn: CustomServiceBtn,
          CustomServiceMoreBtn: CustomServiceMoreBtn
        })]
      })]
    })]
  });
  if (CustomClickCard) {
    return /*#__PURE__*/_jsx(CustomClickCard, {
      data: doctor,
      children: Card
    });
  }
  return Card;
}